import { useState, useMemo } from 'react';
import { scaleOP, fullWidth } from '@components/frame';
import { calculateTableConfig, searchDisplayMode } from '@helpers';
import { SIDEBAR_WIDTH } from '@components/operatorPanel/components/OperatorPanelInformation/components/OperatorPanelInformationSearchNCFilesScreen/constants';
import { getGridConfig } from '@components/operatorPanel/components/OperatorPanelInformation/gridConfig';

export const useOPDisplayMode = () => {
  const [displayMode, setDisplayMode] = useState(searchDisplayMode.block);

  const isSmallMode = displayMode === searchDisplayMode.square;
  const isLineMode = displayMode === searchDisplayMode.line;
  const isTableMode = displayMode === searchDisplayMode.tableStandard || displayMode === searchDisplayMode.tableCompact;

  const effectiveWidth = fullWidth - scaleOP(SIDEBAR_WIDTH);

  const config = useMemo(
    () => getGridConfig(effectiveWidth, isSmallMode),
    [effectiveWidth, isSmallMode]
  );

  const { columns, itemSize } = calculateTableConfig(config);

  return {
    displayMode,
    setDisplayMode,
    isSmallMode,
    isLineMode,
    isTableMode,
    effectiveWidth,
    columns,
    itemSize,
  };
};
